//
//
//
//
//
//
//
//
//

import Api from './api/pay';
import Api2 from './api/personInfo';
import { mapState } from 'vuex';
export default {
	name: 'app',
	data () {
		return {
			loading: true,
			oQuery: undefined
		};
	},
	created () {
	},
	mounted () {
		this.rem();
	},
	computed: {
		...mapState( {
			appType: state => state.payParams.appType,
		} )
	},
	watch: {
		'$route': function ( to, from ) {
			//	跳过下载页，因为下载页需要在浏览器中打开
			if ( to.name === "download" ) {
				return;
			}

			if ( to.query && to.query.companyId ) { this.oQuery = to.query; }
			if ( this.oQuery ) {
				this.getCompanyId( from );
			} else if ( !this.oQuery && !localStorage.getItem( 'parklotInfo' ) ) {
				if ( to.path.indexOf( '/toggleParklot' ) < 0 ) {
					this.$router.push( { path: '/toggleParklot' } );
				}
				// Api2.queryMainParklot().then( res => {
				// 	if ( res.result && res.result.length == 1 ) {
				// 		localStorage.setItem( 'parklotInfo', JSON.stringify( res.result[ 0 ] ) );
				// 		this.$store.commit( 'payParams/getParklotInfo', res.result[ 0 ] );
				// 		this.$vux.toast.show( { text: '选择停车场成功！' } );
				// 	} else {
				// 		if ( to.path.indexOf( '/toggleParklot' ) < 0 ) {
				// 			this.$router.push( { path: '/toggleParklot' } );
				// 		}
				// 	}
				// } );
			}
		}
	},
	methods: {
		rem () {
			( function ( win, doc ) {
				function change () {
					doc.documentElement.style.fontSize = doc.documentElement.clientWidth / 375 * 100 + 'px';
				}
				change();
				win.addEventListener( 'resize', change, false );
				win.addEventListener( 'orientationchange', change, false );
			} )( window, document );
		},
		getCompanyId ( to ) {
			this.$store.commit( 'payParams/getParklotInfoIsSend', true );
			this.$vux.loading.show();
			Api.queryMainParklot().then( res => {
				this.$store.commit( 'payParams/getParklotInfoIsSend', false );
				this.$vux.loading.hide();
				let getNum = 0;
				res.result.forEach( item => {
					if ( item.companyId === this.oQuery.companyId ) {
						localStorage.setItem( 'parklotInfo', JSON.stringify( item ) );
						this.$store.commit( 'payParams/getParklotInfo', item );
						getNum++;
					}
				} );
				if ( getNum === 0 ) {
					this.$vux.toast.show( { text: '信息匹配失败，请手动选择停车场!', type: 'text' } );
					this.$router.push( { path: '/toggleParklot' } );
				}
			} ).catch( err => {
				console.error( err );
				this.$vux.loading.hide();
				this.$vux.toast.show( { text: '信息查询失败，请手动选择停车场!', type: 'text' } );
				this.$router.push( { path: '/toggleParklot' } );
			} );
		},
	}
}



// WEBPACK FOOTER //
// ./src/App.vue